import { render, staticRenderFns } from "./WorkerAssignments.vue?vue&type=template&id=66d2fca6"
import script from "./WorkerAssignments.vue?vue&type=script&lang=js"
export * from "./WorkerAssignments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports